import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { Tag } from '@sb-tools/typescript/models/tag.model';
import { RouterLink } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaceEmojisPipe } from '../../../sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';

@Component({
    selector: 'app-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, TooltipModule, TranslateModule, ReplaceEmojisPipe],
})
export class TagsComponent {
    @Input() tags: Tag[];
    @Input() ticketId: number;

    constructor(public commonDataService: CommonDataService) {}
}
